import Icon from '../../components/Icon.vue'

Icon.register({"brands/google-plus-g":{"width":640,"height":512,"paths":[{"d":"M386.1 228.5C387.9 238.2 389.2 247.9 389.2 260.5 389.2 370.2 315.6 448 204.8 448 98.7 448 12.8 362.1 12.8 256S98.7 64 204.8 64C256.7 64 299.9 82.9 333.4 114.3L281.3 164.3C267.1 150.7 242.3 134.7 204.8 134.7 139.3 134.7 85.9 188.9 85.9 256 85.9 323.1 139.3 377.3 204.8 377.3 280.8 377.3 309.3 322.5 313.8 294.5H204.8V228.5H386.1zM571.5 234.9V179.2H515.5V234.9H459.7V290.9H515.5V346.7H571.5V290.9H627.2V234.9H571.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google-plus-g.js
// module id = TPk4
// module chunks = 0